module.exports = __webpack_public_path__ + "assets/img/rocket.a1daaf8a.png";